import { get } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getLocationSuggestions = async (token, baseUrl, params = {}) => {
  const queryPath = `${baseUrl}/location_lookups/suggest`;

  try {
    const res = await get(token, queryPath, params);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
